var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F0F3F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1V31H31V1H1Z",
    fill: "#1C8FF8",
    fillOpacity: 0.338428
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3891 11.0186C18.5822 10.8348 18.8856 10.8348 19.0787 11.0186L20.2301 12.1149C20.4371 12.312 20.4371 12.6421 20.2301 12.8392L14.1257 18.651C14.0327 18.7395 13.9093 18.7889 13.7809 18.7889H12.5791C12.303 18.7889 12.0791 18.565 12.0791 18.2889V17.2405C12.0791 17.1037 12.1352 16.9728 12.2343 16.8784L18.3891 11.0186Z",
    stroke: "#3F8CFF",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0845 22H21.6845",
    stroke: "#3F8CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEdit);
export default __webpack_public_path__ + "static/media/ContactEdit.2fa97f317e52183ef94095c8fc7a6c5a.svg";
export { ForwardRef as ReactComponent };